import React, { useState } from 'react'
import { Modal } from '@mui/material'
import moment from 'moment'
import { useGetRequest } from '../../../shared/hooks/requests'
import { GET_SIMILARITY_PERSON_INFO } from '../../../shared/utils/urls'

export function SimilarityRangeModal({ id, mainData }) {
    const [open, setOpen] = useState(false)
    const getMainInfo = useGetRequest()
    const getSimilarInfo = useGetRequest()

    const handleOpen = () => {
        setOpen(true)

        // First request: using mainData.identityId
        if (mainData.identityId) {
            getMainInfo.request({ url: `${GET_SIMILARITY_PERSON_INFO}/${mainData.identityId}` })
        }

        // Second request: using similarIdentityId
        if (uniqueSimilarity.similarIdentityId) {
            getSimilarInfo.request({ url: `${GET_SIMILARITY_PERSON_INFO}/${uniqueSimilarity.similarIdentityId}` })
        }
    }
    const handleClose = () => setOpen(false)
    const similarityData = mainData.similarities ? mainData.similarities : []

    // Filter unique similarity data based on the provided id
    const uniqueSimilarity = similarityData.find((item) => item.id === id) || null
    const trimmedTenantEntityName = mainData.tenantEntityName
        ? mainData.tenantEntityName.slice(0, 13)
        : ''
    const trimmedTenantEntityNameSimilar = uniqueSimilarity.similarEntityName
        ? uniqueSimilarity.similarEntityName.slice(0, 13)
        : ''

    const mainInfo = getMainInfo.response || {}
    const similarInfo = getSimilarInfo.response || {}

    console.log(mainInfo, similarInfo)

    return (
        <>
            <button onClick={handleOpen} className="px-[15px] py-[10px] bg-main-300  text-white rounded-[10px]">
                Details
            </button>
            <Modal
                open={open}
                onClose={handleClose}
                className="flex items-center justify-center"
            >
                <div className="w-[600px] flex items-start gap-[20px] h-auto bg-white p-[10px]">
                    <div className="w-[50%] flex flex-col items-center gap-[20px] border h-[100%]">
                        <div className="w-[100%] overflow-hidden h-[300px] border">
                            <img
                                src={mainData.imageUrl}
                                alt="img of the main person"
                                className="w-[100%] h-[100%] object-fill"
                            />
                        </div>
                        <div className="w-[100%] h-[200px] overflow-auto
                         px-[15px] flex flex-col items-center gap-[10px]"
                        >
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[18px]">ID</span>
                                <span>{mainData.identityId}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Entity Name</span>
                                <span>
                                    {trimmedTenantEntityName}
                                    ...
                                </span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Firstname</span>
                                <span>{mainData.firstName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Lastname</span>
                                <span>{mainData.lastName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">TenantEntityId</span>
                                <span>{mainInfo.tenantEntityId}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">PINFL</span>
                                <span>{mainData.pinfl}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Version</span>
                                <span>{mainData.version}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Region</span>
                                <span>{mainInfo.regionName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">District</span>
                                <span>{mainInfo.districtName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">ExternalId</span>
                                <span>{mainInfo.externalId}</span>
                            </div>
                        </div>
                    </div>
                    <div className="w-[50%] h-[100%] flex flex-col items-center gap-[20px] border">
                        <div className="w-[100%] overflow-hidden h-[300px] border">
                            <img
                                src={uniqueSimilarity.similarImageUrl}
                                alt="img of the main person"
                                className="w-[100%] h-[100%] object-fill"
                            />
                        </div>
                        <div className="w-[100%] px-[15px] h-[200px] overflow-auto flex flex-col items-center gap-[10px]">
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[18px]">ID</span>
                                <span>{uniqueSimilarity.similarIdentityId}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[18px]">TenantEntityId</span>
                                <span>{uniqueSimilarity.similarTenantEntityId}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Entity Name</span>
                                <span>
                                    {trimmedTenantEntityNameSimilar}
                                    ...
                                </span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Firstname</span>
                                <span>{uniqueSimilarity.similarIdentityFirstName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Lastname</span>
                                <span>{uniqueSimilarity.similarIdentityLastName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">CreatedAt</span>
                                <span>{moment(uniqueSimilarity.createdAt).format('YYYY-MM-DD HH:mm')}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Version</span>
                                <span>{uniqueSimilarity.similarVersion}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">Region</span>
                                <span>{similarInfo.regionName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">District</span>
                                <span>{similarInfo.districtName}</span>
                            </div>
                            <div className="w-[100%] flex items-center justify-between">
                                <span className="text-black font-[600] text-[15px]">ExternalId</span>
                                <span>{similarInfo.externalId}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
